import { render, staticRenderFns } from "./ProjectViewRecordings.vue?vue&type=template&id=2530bc06&"
import script from "./ProjectViewRecordings.vue?vue&type=script&lang=js&"
export * from "./ProjectViewRecordings.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewRecordings.vue?vue&type=style&index=0&id=2530bc06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VOverlay,VProgressCircular,VRow,VSlider})
